import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import InputText from '@/views/fragments/form/InputText'
import ToggleButton from '@/views/fragments/form/ToggleButton'
import {
  formatterNumberOnly,
} from '@/utils/formatter'
import {
  FormContainer,
  StyledBasicData,
} from './styles'

const TypeVehicleForm = (props) => {
  const {
    onChange,
    formValues,
  } = props

  
  useEffect(() => {
  }, [])


  const handleChange = (e, ml) => {
    const { value, name} = e.target

    if (formatterNumberOnly(value).length > ml) return

    onChange({
      ...formValues,
      [name]: value
    })
  }
  const handleChangeToggle = (name, bool) => {
    onChange({
      ...formValues,
      [name]: bool ? 1 : 0
    })
  }

  return (
    <>
      <FormContainer>
        <StyledBasicData>
          <h3>Dados Básicos</h3>
          <InputText
            value={formValues.nome || ''}
            name="nome"
            onChange={handleChange}
            label="Nome"
          />
          <InputText
            value={formValues.quantidade_placa || ''}
            name="quantidade_placa"
            type="number"
            onChange={handleChange}
            label="Quantidade de Placas"
          />
          <ToggleButton
            label="Status Ativo?"
            value={Number(formValues.status) === 1 || false}
            name="status"
            onClick={handleChangeToggle}
          />
        </StyledBasicData>
      </FormContainer>
    </>
  )
}

TypeVehicleForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  goToDriver: PropTypes.func,
  formValues: PropTypes.objectOf(PropTypes.any).isRequired,
  isEdit: PropTypes.bool
}

TypeVehicleForm.defaultProps = {
  isEdit: false,
  goToDriver: null
}

export default TypeVehicleForm
